<script>
export default {
    props: ['data'],
    name: "productSwiper",
    data() {
        return {
            swiperOptions: {
                observer: true,
                observeParents: true,
                simulateTouch: false,
                loop: false,
                navigation: {
                    nextEl: '.product_swiper .swiper-button-next',
                    prevEl: '.product_swiper .swiper-button-prev',
                },
                slidesPerView: 4,
                slidesPerGroup: 4,
                spaceBetween: '1%',
            },
        };
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.$swiper
        }
    },
    components: {
        
    },
    mounted() {
        
    },
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="product_swiper">
        <swiper class="swiper" ref="mySwiper" :options="swiperOptions">
            <swiper-slide v-for="(item, index) in data" :key="index">
                <router-link class="item" :to="`/shop/detail?id=${item.id}`">
                    <div class="layout_bg cover" :style="`background-image: url(${item.image});`"></div>
                    <div class="name">{{ item.name }}</div>
                    <div class="price">RMB {{ item.price }}</div>
                </router-link>
            </swiper-slide>
        </swiper>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
    </div>
</template>

<style scoped lang="scss">
.product_swiper{
    padding: 0 .8rem;
    position: relative;
    .item{
        // flex: 1;
        // width: 2.5rem;
        text-align: center;
        display: flex;
        flex-direction: column;
        gap: .2rem;
        .cover{
            height: 0;
            padding-bottom: 100%;
        }
        .name{
            font-size: .18rem;
        }
        .price{
            font-size: .17rem;
        }
    }
    --swiper-navigation-color: #fff;/* 单独设置按钮颜色 */
    --swiper-navigation-size: .2rem;/* 设置按钮大小 */
    .swiper-button-prev,
    .swiper-button-next{
        top: 1.25rem;
        margin-top: 0;
        transform: translate(0, -50%);
        padding: .4rem;
        &.swiper-button-disabled{
            opacity: 0;
        }
    }
    .swiper-button-prev{
        left: 0;
    }
    .swiper-button-next{
        right: 0;
    }
}
</style>